import React from "react";
import DropdownSelect from "../../dropdown/Dropdown";
import TextInput from "../../UIComponent/TextInput";
import Validation from "../../../utils/validation/ValidationText";
import ImageCropperWithUpload from "../../ImageUpload/UploadImage";
import moment from "moment";
import SingleSelectWithSearch from "../../dropdown/SingleSelectWithSearch/SingleSelectWithSearch";
import Selector from "../../dropdown/commonDropdown/Selector";
import ImageUploadTest from "../../ImageUpload3/ImageUploadTest";
import validate from "../../../utils/validation/CommonValidator";


function IndividualBasicInformation(props) {
  return (
    <div className="w-full">
      <div className="2xl:py-5 lg:py-5">
        <div className="grid grid-cols-12 gap-6 w-full items-start">
          {/* CSIS Membership Number & Member Name */}
          <div className="col-span-12 grid grid-cols-12 gap-6">
            <div className="xl:col-span-6 col-span-12">
              <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                CSIS Membership Number <span className="text-[#c00000]">*</span>
              </h2>
              <div className="dropdwn-input flex items-center">
                <TextInput
                  placeholder=""
                  type="text"
                  name="csisMembershipNo"
                  value={props.individualProfile.csisMembershipNo}
                  identity="BasicInformation"
                  handleChange={props.handleChange}
                  onBlur={(e) => props.validate("csisMembershipNo")}
                 
                />
              </div>
              <Validation error={props.validState.error.csisMembershipNo} />
            </div>

            <div className="xl:col-span-6 col-span-12">
              <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                Member Name <span className="text-[#c00000]">*</span>
              </h2>
              <div className="dropdwn-input flex items-center">
                <TextInput
                  placeholder=""
                  type="text"
                  name="memberName"
                  value={props.individualProfile.memberName}
                  identity="BasicInformation"
                  handleChange={props.handleChange}
                  onBlur={(e) => props.validate("memberName")}
               
                />
              </div>
         
              <Validation error={props.validState.error.memberName} />
            </div>
          </div>
       
          {/* Mobile Number & Email Address */}
          <div className="col-span-12 grid grid-cols-12 gap-6">
            <div className="xl:col-span-6 col-span-12">
              <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                Mobile Number <span className="text-[#c00000]">*</span>
              </h2>
              <TextInput
                placeholder=""
                type="text"
                name="mobileNumber"
                value={props.individualProfile.mobileNumber}
                identity="BasicInformation"
                handleChange={props.handleChange}
                onBlur={(e) => props.validate("mobileNumber")}
              />
              <Validation error={props.validState.error.mobileNumber} />
            </div>

            <div className="xl:col-span-6 col-span-12">
              <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                Email Address <span className="text-[#f72b2b]">*</span>
              </h2>
              <div className="dropdwn-input-email flex items-center">
                <TextInput
                  placeholder=""
                  type="text"
                  name="emailAddress"
                  value={props.individualProfile.emailAddress}
                  identity="BasicInformation"
                  handleChange={props.handleChange}
                  onBlur={(e) => props.validate("emailAddress")}
                />
              </div>
              <Validation error={props.validState.error.emailAddress} />
              <Validation error={props.validState.error.emailString} />
            </div>
          </div>
        </div>
      </div>
      <div className="xl:col-span-6 lg:col-span-6 col-span-12">
            <div className="grid grid-cols-12 gap-6">
              <div className="xl:col-span-6 lg:col-span-11 col-span-12">
                <h2 className="text-xl text-[#757575] font-bold xl:mb-1">
                  Membership Type<span className="text-[#c00000]">*</span>
                </h2>
                <DropdownSelect
                  drpIdentity={"membershipTypes"}
                  optionArray={props.membershipTypes}
                  setFilterParameters={props.setFilterParameters}
                  value={props.individualProfile.membershipTypeId}
                  onBlur={(e) => props.validate("membershipTypes")}
                />
                <Validation error={props.validState.error.membershipTypeId} />
              </div>
            </div>
          </div>

      {/* Save Button */}
      <div className="grid grid-cols-12 gap-6 pb-10">
        <div className="col-span-12 px-10">
          <div className="flex items-center justify-end">
            <button
              className="w-32 px-7 py-3 btn-sm btn-red text-xl text-white font-semibold"
              onClick={() => props.onSave()}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default IndividualBasicInformation;
